export function adjustColor(color: number, range: number): number {
    let r = (color >> 16) & 0xFF;
    let g = (color >> 8) & 0xFF;
    let b = color & 0xFF;

    const offset = Math.floor(Math.random() * range * 2) - range;

    r = Math.min(255, Math.max(0, r + offset));
    g = Math.min(255, Math.max(0, g + offset));
    b = Math.min(255, Math.max(0, b + offset));

    return (r << 16) | (g << 8) | b;
}
